import { FunctionComponent } from 'react';
import { Price } from '../../types/Account';

type CheckoutHeaderProps = {
  title: string;
  lookupKey?: string;
  lookupPrice?: Price;
};

const CheckoutHeader: FunctionComponent<CheckoutHeaderProps> = ({
  title,
  lookupKey,
  lookupPrice,
}) => {
  return (
    <>
      <h3>{title}</h3>
      <p className="dim min-h-[48px] text-pretty">
        {lookupPrice ? (
          lookupPrice.product.name
        ) : lookupKey ? (
          'Loading plan…'
        ) : (
          <>
            GoFullPage Premium 1-year subscription.
            <br />
            Try for 7 days with no-hassle, easy cancellation.
          </>
        )}
      </p>
    </>
  );
};

CheckoutHeader.displayName = 'CheckoutHeader';

export default CheckoutHeader;
